"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _CasaOldBreadcrumbHelper = require("./helpers/CasaOldBreadcrumbHelper");

var _SeoManagerHelpers = require("./helpers/SeoManagerHelpers");

var _helpers = require("./utils/helpers");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var BaseSeoManager = /*#__PURE__*/function () {
  function BaseSeoManager(domain, lang) {
    _classCallCheck(this, BaseSeoManager);

    this.domain = domain || 'casa.it';
    this.lang = lang || 'it';
    this.data = {};
    this.num_levels = 0;
    this.seo_data = {};
    this.valid_levels = {
      level1: null,
      level2: null,
      level3: null,
      level4: null,
      level5: null,
      level6: null,
      level7: null
    };
    this.valid_geo_levels = {};
  }

  _createClass(BaseSeoManager, [{
    key: "clean",
    value: function clean() {
      this.data = {};
      this.num_levels = 0;
      this.seo_data = {};
    }
  }, {
    key: "getParts",
    value: function getParts(url) {
      url = url.replace(/(.*)(\/%20)(.*)/g, '$1\+%20$3'); // CLEAN OLD URL with '/' in the path of the zone

      var ret = url.split('/').slice(1, -1);
      this.num_levels = ret.length;
      return ret;
    }
  }, {
    key: "addData",
    value: function addData(key, value) {
      this.data[key] = value;
    }
  }, {
    key: "addDecodeData",
    value: function addDecodeData(key, value) {
      if (!this.data.seo_decode_type) {
        this.data.seo_decode_type = {};
      } // console.log('addDecodeData', key, value);


      this.data.seo_decode_type[key] = value;
    }
  }, {
    key: "getData",
    value: function getData() {
      return this.data;
    }
  }, {
    key: "getSeoLevels",
    value: function getSeoLevels() {
      if (Array.isArray(this.data.geo)) {
        var seo = [];
        this.data.geo.map(function (g) {
          seo.push({
            seo: g
          });
        });
        return seo;
      }

      return this.data.geo && Object.keys(this.data.geo).length > 0 ? [{
        seo: this.data.geo
      }] : [];
    }
    /**
     *  Agency name has to be inside where for apiReq esapi
     * @returns Array
     */

  }, {
    key: "getNameWhereLevel",
    value: function getNameWhereLevel() {
      if (this.data && this.data.queryObject && this.data.queryObject.name) {
        return [{
          name: this.data.queryObject.name
        }];
      }

      return [];
    }
  }, {
    key: "getFreeTexts",
    value: function getFreeTexts() {
      if (Array.isArray(this.data.freetext)) {
        return this.data.freetext;
      }

      return this.data.freetext ? [this.data.freetext] : [];
    }
  }, {
    key: "getPostalCodes",
    value: function getPostalCodes() {
      if (Array.isArray(this.data.postalcode)) {
        return this.data.postalcode;
      }

      return this.data.postalcode ? [this.data.postalcode] : [];
    }
  }, {
    key: "getFilters",
    value: function getFilters() {
      var MIN_REGEX = /min-(\d{1,}$)/g;
      var MAX_REGEX = /max-(\d{1,}$)/g;
      var filters = {};

      if (this.data.tr) {
        filters['transaction.type'] = _SeoManagerHelpers.TR_DECODE_FOR_ESAPI[this.lang][this.data.tr];
      }

      if (this.data.category) {
        filters.category = _SeoManagerHelpers.CAT_DECODE_FOR_ESAPI[this.lang][this.data.category];
      }

      if (this.data.propertyTypeGroup) {
        filters['property_type_group'] = _SeoManagerHelpers.CAT_DECODE_FOR_ESAPI[this.lang][this.data.propertyTypeGroup];
      }

      if (this.data.propertyTypes) {
        if (!Array.isArray(this.data.propertyTypes)) {
          this.data.propertyTypes = [this.data.propertyTypes];
        }

        filters['property.types'] = this.data.propertyTypes.map(function (el) {
          return el.slug;
        });
      } else if (this.data.wrongPropertyTypes) {
        filters['property.types'] = this.data.wrongPropertyTypes;
      }

      if (this.data.license_type_groups) {
        if (!Array.isArray(this.data.license_type_groups)) {
          this.data.license_type_groups = [this.data.license_type_groups];
        }

        filters['license_type_groups'] = this.data.license_type_groups.map(function (el) {
          return el.slug;
        });
      }

      if (this.data.price) {
        filters.price = Object.assign({}, this.data.price.from ? {
          gte: this.data.price.from
        } : null, this.data.price.to ? {
          lte: this.data.price.to
        } : null);
      }

      if (this.data.queryObject && this.data.queryObject.mqprice) {
        var mqprice = {
          value: this.data.queryObject.mqprice
        };
        mqprice.value.split(',').map(function (a) {
          var match1 = MIN_REGEX.exec(a);
          var match2 = MAX_REGEX.exec(a);

          if (match1) {
            mqprice.from = match1[1];
          }

          if (match2) {
            mqprice.to = match2[1];
          }
        });
        filters.mqprice = Object.assign({}, mqprice.from ? {
          gte: mqprice.from
        } : null, mqprice.to ? {
          lte: mqprice.to
        } : null);
      }

      if (this.data.mq) {
        filters.surface = Object.assign({}, this.data.mq.from ? {
          gte: this.data.mq.from
        } : null, this.data.mq.to ? {
          lte: this.data.mq.to
        } : null);
      }

      if (this.data.queryObject && this.data.queryObject.numParkingSpaces) {
        filters.carparks = Object.assign({}, this.data.queryObject.numParkingSpaces ? {
          gte: this.data.queryObject.numParkingSpaces
        } : null);
      }

      if (this.data.queryObject && this.data.queryObject.buildingYearRange) {
        var buildingYearRange = {
          value: this.data.queryObject.buildingYearRange
        };
        buildingYearRange.value.split(',').map(function (a) {
          var match1 = MIN_REGEX.exec(a);
          var match2 = MAX_REGEX.exec(a);

          if (match1) {
            buildingYearRange.from = match1[1];
          }

          if (match2) {
            buildingYearRange.to = match2[1];
          }
        });
        filters.building_year = Object.assign({}, buildingYearRange.from ? {
          gte: buildingYearRange.from
        } : null, buildingYearRange.to ? {
          lte: buildingYearRange.to
        } : null);
      }

      if (this.data.queryObject && this.data.queryObject.payment) {
        var payment = {
          value: this.data.queryObject.payment
        };
        payment.value.split(',').map(function (a) {
          var match1 = MIN_REGEX.exec(a);
          var match2 = MAX_REGEX.exec(a);

          if (match1) {
            payment.from = match1[1];
          }

          if (match2) {
            payment.to = match2[1];
          }
        });
        filters.payment = Object.assign({}, payment.from ? {
          gte: payment.from
        } : null, payment.to ? {
          lte: payment.to
        } : null);
      }

      if (this.data.rooms) {
        filters.rooms = {
          gte: this.data.rooms
          /* , lte:  this.data.rooms */

        };
      }

      if (this.data.numRoomsMin || this.data.numRoomsMax) {
        filters.rooms = {};

        if (this.data.numRoomsMin) {
          filters.rooms.gte = this.data.numRoomsMin;
        }

        if (this.data.numRoomsMax) {
          filters.rooms.lte = this.data.numRoomsMax;
        }
      }

      if (this.data && this.data.queryObject && this.data.queryObject.agencyName) {
        filters.agencyName = this.data.queryObject.agencyName;
      }

      if (this.data.queryObject && this.data.queryObject.exteriorFeatures) {
        var exteriorFeatures = this.data.queryObject.exteriorFeatures.split(',');
        exteriorFeatures.map(function (el) {
          switch (el.toLocaleLowerCase()) {
            case 'giardino-giardino-comune':
            case 'giardino-giardinocomune':
            case 'giardino-comune':
            case 'giardino-giardino-privato':
            case 'giardino-giardinoprivato':
            case 'giardino-privato':
              filters['garden.type'] = el.replace(/giardino-giardino/g, 'giardino');
              break;

            case 'balcone':
              filters.balcony = true;
              break;

            case 'terrazzo':
              filters.terrace = true;
              break;

            default:
              break;
          }
        });
      }

      if (this.data.queryObject) {
        if (this.data.queryObject.heatingType) {
          if (!Array.isArray(this.data.queryObject.heatingType)) {
            this.data.queryObject.heatingType = [this.data.queryObject.heatingType];
          }

          filters['heating.types'] = this.data.queryObject.heatingType.map(function (ht) {
            return ht.replace(/\+/g, '-').replace(/riscaldamento-/g, '');
          });
        }

        if (this.data.queryObject.numParkingSpaces) {
          filters.carparks = {
            gte: this.data.queryObject.numParkingSpaces
          };
        }

        if (this.data.queryObject.lift) {
          if (typeof this.data.queryObject.lift === 'boolean' || isNaN(this.data.queryObject.lift)) {
            filters.lift = this.data.queryObject.lift;
          } else {
            filters.lift = true;
            filters.lift_level = parseInt(this.data.queryObject.lift, 10);
          }
        }

        if (this.data.queryObject.level) {
          if (isNaN(this.data.queryObject.level)) {
            filters.level = this.data.queryObject.level;
          } else {
            filters.level = {
              gte: parseInt(this.data.queryObject.level, 10)
            };
          }
        }

        if (this.data.queryObject.garden) {
          if (!Array.isArray(this.data.queryObject.garden)) {
            this.data.queryObject.garden = [this.data.queryObject.garden];
          }

          filters['garden.type'] = this.data.queryObject.garden.map(function (ht) {
            return ht.replace(/\+/g, '-').replace(/giardino-/g, '');
          });
        }

        if (this.data.queryObject.balcony) {
          filters.balcony = this.data.queryObject.balcony;
        }

        if (this.data.queryObject.terrace) {
          filters.terrace = this.data.queryObject.terrace;
        }

        if (this.data.queryObject.only_auction) {
          filters.only_auction = this.data.queryObject.only_auction;
        }

        if (this.data.queryObject.has_swimming_pool) {
          filters.has_swimming_pool = this.data.queryObject.has_swimming_pool;
        }

        if (this.data.queryObject.availability) {
          filters.availability = this.data.queryObject.availability;
        }

        if (this.data.queryObject.photo) {
          filters.only_with_photos = this.data.queryObject.photo;
        }

        if (this.data.queryObject.misc && this.data.queryObject.misc.toLocaleLowerCase() === 'photo-only') {
          filters.only_with_photos = true;
        }

        if (this.data.queryObject.buildingCondition) {
          filters.building_condition = this.data.queryObject.buildingCondition.split(/,/);
          filters.buildingCondition = this.data.queryObject.buildingCondition;
        }
      }

      if (this.data.queryObject && this.data.queryObject.misc) {
        var misc = Array.isArray(this.data.queryObject.misc) ? this.data.queryObject.misc[0] : this.data.queryObject.misc;

        if (misc.toLocaleLowerCase() === 'photo-only') {
          filters.only_with_photos = true;
        }
      }

      if (this.data.queryObject && this.data.queryObject.activeSort) {
        filters.sortType = this.data.queryObject.activeSort;
      } else if (this.data.queryObject && this.data.queryObject.sortType) {
        filters.sortType = this.data.queryObject.sortType;
      }

      var sellerType = this.data.publisher || this.data.publisherType || null;

      if (sellerType && !Array.isArray(sellerType)) {
        sellerType = [sellerType];
      }

      if (sellerType) {
        filters.sellerType = sellerType;
        filters['publisher.category'] = sellerType;
      }

      if (this.data.publisherId) {
        if (this.data.isAgentProPage) {
          if (this.data.queryObject && this.data.queryObject.agentName) {
            filters['name'] = this.data.queryObject.agentName;
          }

          try {
            filters['casa_parent_publisher_id'] = parseInt(this.data.publisherId);
          } catch (error) {
            console.log('Error parsing agentPro agency number >>:', error);
            filters['casa_parent_publisher_id'] = this.data.publisherId;
          }
        } else {
          filters['publisher.id'] = this.data.publisherId;
        }
      }

      if (this.data.page) {
        filters.page = this.data.page;
      }

      if (this.data.zone) {
        var zones = this.data.zone.split(',');
        var zonesOK = [];
        zones.map(function (z) {
          if (!isNaN(z)) {
            z = "Z-".concat(z);
          }

          zonesOK.push(z);
        });
        filters.zones = zonesOK.join(',');
      }

      if (this.data.queryObject) {
        if ('includeSurrounding' in this.data.queryObject) {
          filters.surrounding = this.data.queryObject.includeSurrounding;
        } else if ('surrounding' in this.data.queryObject) {
          filters.surrounding = this.data.queryObject.surrounding;
        }
      }

      if (this.data.isRoomsNumber === true) {
        filters.isRoomsNumber = this.data.isRoomsNumber;
      }

      if (this.data.buildingCondition) {
        filters.building_condition = this.data.buildingCondition.split(/,/);
        filters.buildingCondition = this.data.buildingCondition;
      }

      if (this.data.poi && (this.data.poi.subway || this.data.poi.electric_charging)) {
        filters.poi = this.data.poi;
      }

      return filters;
    }
  }, {
    key: "getApiParams",
    value: function getApiParams() {
      var isSrpUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (isSrpUrl) {
        this.data = (0, _helpers.normalizeSrpUrlData)(this.data);
      }

      var tmp_filters = this.getFilters();
      var filters = Object.keys(tmp_filters).length ? tmp_filters : {};
      var where = this.getSeoLevels().concat(this.getFreeTexts()).concat(this.getPostalCodes()).concat(this.getNameWhereLevel());
      var ret = {
        where: where,
        filters: filters
      };
      return ret;
    }
  }, {
    key: "createBreadcrumb",
    value: function createBreadcrumb(locations) {
      this.seo_data.breadcrumb = (0, _CasaOldBreadcrumbHelper.createBreadcrumb)(Object.assign({}, this.data, {
        locations: locations
      }));
    }
  }, {
    key: "getSeoData",
    value: function getSeoData() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          locations = _ref.locations,
          total_listings = _ref.total_listings,
          moreDetail = _ref.moreDetail,
          _ref$prtFilters = _ref.prtFilters,
          prtFilters = _ref$prtFilters === void 0 ? {} : _ref$prtFilters,
          _ref$seoParams = _ref.seoParams,
          seoParams = _ref$seoParams === void 0 ? {} : _ref$seoParams,
          _ref$isSrpUrl = _ref.isSrpUrl,
          isSrpUrl = _ref$isSrpUrl === void 0 ? false : _ref$isSrpUrl;

      // this.createBreadcrumb(locations);
      this.createSeoData({
        locations: locations,
        total_listings: total_listings,
        moreDetail: moreDetail,
        prtFilters: prtFilters,
        seoParams: seoParams,
        isSrpUrl: isSrpUrl
      });
      return this.seo_data;
    }
  }, {
    key: "getSeoPageLinks",
    value: function getSeoPageLinks(pages) {
      var pagelink = {};

      if (pages && pages.cur && pages.tot) {
        var pageLista = (0, _SeoManagerHelpers.getListaFromUri)(pages.uri);

        if (pageLista) {
          pages.cur = parseInt(pageLista, 10);
        } else {
          pages.cur = parseInt(pages.cur, 10);
        }

        var isPageLista = !!pageLista;
        pages.tot = parseInt(pages.tot, 10);

        if (pages.uri) {
          if (isPageLista) {
            pages.uri = pages.uri.replace(/\lista-\d.*/g, '');
          } else {
            pages.uri = pages.uri.replace(/\?page=\d*|&page=\d*/g, '');
          }
        }

        var pageuri = isPageLista ? "".concat(pages.uri, "lista-") : "".concat(pages.uri).concat(pages.uri.indexOf('?') > -1 && pages.cur ? '&' : '?', "page=");

        if (pages.cur === 1 && pages.tot > 1) {
          pagelink.next = "".concat(pageuri.replace('/?page=', '?page=')).concat(pages.cur + 1);
        }

        if (pages.cur > 1 && pages.cur < pages.tot) {
          pagelink.prev = "".concat(pageuri).concat(pages.cur - 1);

          if (pages.cur === 2) {
            pagelink.prev = pagelink.prev.replace('?page=1', '/').replace('&page=1', '');
          }

          pagelink.next = "".concat(pageuri).concat(pages.cur + 1);
        }

        if (pages.cur > 1 && pages.cur === pages.tot) {
          pagelink.prev = "".concat(pageuri).concat(pages.cur - 1);
        }
      }

      return pagelink;
    }
  }, {
    key: "isValidDecode",
    value: function isValidDecode() {
      var _this = this;

      var valid = true;
      Object.keys(this.valid_levels).map(function (level) {
        if (valid) {
          if (_this.valid_levels[level] === false) {
            valid = false;
          }
        }
      });
      return valid;
    }
  }, {
    key: "decode",
    value: function decode(url) {
      var _this2 = this;

      var manager_type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
      url = url.toLocaleLowerCase();
      var parts = this.getParts(url); // console.log("- BASE DECODE -");
      // console.log(this.data);

      this.clean();
      var level = 1;

      if (manager_type != undefined) {
        this.addData('seo_manager_type', manager_type);
      }

      parts.map(function (el, index) {
        if (el.length) {
          _this2.decodeLevel(level, el, parts.length);

          level += 1;
        }
      });

      if (parts && parts.length > 0) {
        return this.getData();
      } else {
        return this.decodeHome();
      }
    }
  }, {
    key: "decodeHome",
    value: function decodeHome() {
      this.data.seo_manager_type = 'home';
      this.valid_levels.level1 = false;
      this.data.seo_decode_type = {};
      return this.data;
    }
  }]);

  return BaseSeoManager;
}();

var _default = BaseSeoManager;
exports["default"] = _default;